<template>
	<div class="box_infps_editors" :class="{ box_flexs: activeScreen }">
		<quill-editor
			v-model="myParams[getKeyWord]"
			v-if="showEdit"
			ref="editorComp"
			class="ql-toolbar"
			:options="editorOption"
			clearable
			@change="onEditorChange($event)"
			data-placeholder="sjoihdisan"
		>
			<!--      :class="{'name_toolbar':keyWord=='title'}"-->
		</quill-editor>
		<div class="font_box_info_tabs" @click="changInfoCase">
			<img
				v-if="activeScreen == false"
				src="http://taotan-oss.oss-cn-zhangjiakou.aliyuncs.com/kylin/2022391738"
			/>
			<img
				v-if="activeScreen == true"
				src="http://taotan-oss.oss-cn-zhangjiakou.aliyuncs.com/kylin/20223917324"
			/>
		</div>
	</div>
</template>

<script>
import { quillEditor, Quill } from "vue-quill-editor";
import { ImageExtend, QuillWatch } from "quill-image-extend-module";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Quill.register("modules/ImageExtend", ImageExtend);
const Delta = Quill.import("delta");
export default {
	name: "richText",
	props: ["keyWord", "params"],
	components: {
		quillEditor,
	},
	data() {
		const that = this;
		return {
			getKeyWord: this.keyWord, //接收动态keyWord的值
			myParams: this.params, //接收动态params的值
			editorOption: {},
			uploadImage: "",
			imgContent: {},
			showEdit: false,
			activeScreen: false,
		};
	},
	created() {},
	mounted() {
		this.GetAliOss();
	},
	watch: {
		params: {
			handler(newValue, oldValue) {
				this.myParams = newValue;
			},
			deep: true,
		},
	},
	methods: {
		changInfoCase() {
			this.activeScreen = !this.activeScreen;
		},
		async GetAliOss() {
			const { data: resData } = await this.$get("aliyun/oss/sign", {});
			if (resData.result != 200) return;
			this.uploadImage = resData.data.host;
			this.imgContent = resData.data;
			this.showEdit = true;
			this.setEditorOption();
		},
		setEditorOption() {
			// 当前组件实例
			let basrs = [
				["bold", "italic", "underline", "strike"], // toggled buttons
				[{ color: [] }, { background: [] }], // dropdown with defaults from theme
				// ["blockquote", "code-block"],
				[{ header: 1 }, { header: 2 }], // custom button values
				[{ list: "ordered" }, { list: "bullet" }],
				[{ script: "sub" }, { script: "super" }], // superscript/subscript
				["image", "link"], //"link", "video"
				[{ indent: "-1" }, { indent: "+1" }], // outdent/indent
				[{ direction: "rtl" }], // text direction

				[{ align: [] }],
				// [{ font: [] }],
				// [{ size: ["small", false, "large", "huge"] }], // custom dropdown
				// [{ header: [1, 2, 3, 4, 5, 6, false] }],
				// ["clean"], // remove formatting button
			];
			let name_basrs = [
				[{ color: [] }], // dropdown with defaults from theme
			];
			let vm = this;
			this.editorOption = Object.assign(this.editorOption, {
				placeholder: "请输入内容...",
				modules: {
					toolbar: {
						// container:this.keyWord=='title'? name_basrs :basrs,
						container: basrs,
						handlers: {
							// 自定义上传图片到服务器
							image: function () {
								// quill插件实例
								let _self = this;
								// 创建上传文件input并触发
								let fileInput = document.createElement("input");
								fileInput.setAttribute("type", "file");
								fileInput.setAttribute("multiple", "multiple");
								fileInput.setAttribute("accept", "image/*");
								fileInput.addEventListener("change", () => {
									if (fileInput.files !== null) {
										const files = Array.from(fileInput.files).reverse();
										// 利用es6迭代器异步顺序上传图片，保证图片插入顺序正常
										const it = files[Symbol.iterator]();
										uploadFile();

										function uploadFile() {
											const { done, value: _file } = it.next();
											if (done) return;
											let reader = new FileReader();
											reader.onload = (event) => {
												const range = _self.quill.getSelection(true);
												// 设置图片上传地址
												const uploadImgServer = vm.uploadImage;
												// 创建formData参数提交（文件+签名信息）
												const formData = new FormData();
												formData.append(
													"key",
													vm.imgContent.dir + vm.getTimes() + _file.name
												); //存储在oss的文件路径
												formData.append(
													"OSSAccessKeyId",
													vm.imgContent.accessid
												); //accessKeyId
												formData.append("policy", vm.imgContent.policy); //policy
												formData.append("Signature", vm.imgContent.signature); //签名
												formData.append("success_action_status", 200); //成功后返回的操作码
												formData.append("file", _file);
												// 发送图片上传请求
												const xhr = new XMLHttpRequest();
												xhr.open("POST", uploadImgServer);
												xhr.timeout = 6000;
												xhr.ontimeout = () => {
													alert("图片上传超时");
												};
												xhr.onreadystatechange = () => {
													let result;
													if (xhr.readyState === 4) {
														// http status code
														if (xhr.status < 200 || xhr.status >= 300) {
															return alert(
																`上传图片发生错误，上传图片发生错误，服务器返回状态是 ${xhr.status}`
															);
														}
														result = xhr.responseText;
														// 根据服务器返回的结果自行拼接图片地址
														const URI =
															vm.uploadImage + "/" + formData.getAll("key");
														// 插入到文本
														_self.quill.updateContents(
															new Delta()
																.retain(range.index)
																.delete(range.length)
																.insert({ image: URI })
														);
													}
													setTimeout(() => {
														// 上传下一个图片
														uploadFile();
													}, 500);
												};
												xhr.send(formData);
											};
											reader.readAsDataURL(_file);
										}
									}
								});
								fileInput.click();
							},
						},
					},
				},
			});
			this.$nextTick(() => {
				this.showEditor = true;
			});
		},
		// 文本改变后同步回父组件绑定的值
		onEditorChange(event) {
			this.$emit("input", event.html);
		},

		getTimes() {
			let data = new Date();
			let year = data.getFullYear().toString();
			let month = data.getMonth() + 1;
			return (
				year +
				month +
				data.getDate() +
				data.getHours() +
				data.getMinutes() +
				data.getSeconds()
			);
		},
		wake() {},
	},
};
</script>
<style scoped></style>
<style>
.ql-toolbar .ql-container.ql-snow {
	height: 160px;
	overflow-y: auto;
}

.name_toolbar .ql-container.ql-snow {
	height: 60px;
	overflow-y: auto;
}

.ql-toolbar.ql-snow {
	line-height: normal !important;
}

/*.el-form-item__content {*/
/*  line-height: normal !important;*/
/*}*/

.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
	padding-left: 0 !important;
	text-indent: 1em;
}

.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
	padding-left: 0 !important;
	text-indent: 2em;
}

.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
	padding-left: 0 !important;
	text-indent: 3em;
}

.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
	padding-left: 0 !important;
	text-indent: 4em;
}

.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
	padding-left: 0 !important;
	text-indent: 5em;
}

.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
	padding-left: 0 !important;
	text-indent: 6em;
}

.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
	padding-left: 0 !important;
	text-indent: 7em;
}

.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
	padding-left: 0 !important;
	text-indent: 8em;
}

.box_infps_editors {
	position: relative;
}

.font_box_info_tabs {
	position: absolute;
	right: 10px;
	top: 10px;
}

.font_box_info_tabs img {
	width: 24px;
	height: 24px;
}

.box_flexs {
	width: 100vw;
	height: 100vh;
	position: fixed;
	left: 0;
	top: 0;
	background: #ffffff;
	z-index: 9999;
}

.box_flexs .ql-toolbar .ql-container.ql-snow {
	height: 90vh !important;
	overflow-y: auto;
}
</style>
